import { CopyButton } from '@/components/copy-button';
import { Tooltip } from '@/components/tooltip';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import { ComponentProps, ReactNode } from 'react';

type ButtonPropsWithTestId = ComponentProps<typeof Button> & { 'data-testid'?: string };

export const StartOrJoinSession = ({
  label,
  url,
  whenUrlEmptyRender,
  canCopyUrl,
  startButtonProps = {},
  disabledTooltip,
}: {
  label: string;
  url?: string | null;
  whenUrlEmptyRender?: ReactNode;
  startButtonProps?: ButtonPropsWithTestId;
  canCopyUrl?: boolean;
  disabledTooltip?: string;
}) => {
  if (!whenUrlEmptyRender) {
    whenUrlEmptyRender = <Button disabled>{label}</Button>;
  }

  if (url && disabledTooltip) {
    return (
      <Tooltip
        trigger={
          <span className="inline-block cursor-not-allowed">
            <Button icon={ExternalLink} {...startButtonProps} type="button" disabled>
              {label}
            </Button>
          </span>
        }
      >
        {disabledTooltip}
      </Tooltip>
    );
  }

  return url ? (
    <div className="flex gap-2">
      <a href={url} target="_blank" rel="noreferrer noopener">
        <Button icon={ExternalLink} {...startButtonProps} type="button">
          {label}
        </Button>
      </a>
      {canCopyUrl && <CopyButton content={url} />}
    </div>
  ) : (
    whenUrlEmptyRender
  );
};
